export enum INDICATOR_TYPE {
  NONE = 'none',
  BLOCK = 'block',
  BUTTON = 'button',
}
